module.exports = __webpack_public_path__ + "img/logo.71414850.png";